import React,{useContext,useMemo} from 'react';
import {Internals,useVideoConfig} from 'remotion';
import type {CodeItem} from '../../vendor/src/features/remotion-editor/editor/items/code/code-item-type';

/** Pinned Remotion 4.0.471 contract: the outer Sequence still clips visibility.
 * Only the generated subtree sees the authored local frame and duration. A nested
 * Sequence alone would clamp duration back to the cut and change useVideoConfig(). */
export function CodeClockBoundary({item,children}:{item:CodeItem;children:React.ReactNode}){
  const parent=useContext(Internals.SequenceContext),{fps}=useVideoConfig();
  const context=useMemo(()=>parent&&item.codeClock?{...parent,
    relativeFrom:parent.relativeFrom+item.codeClock.startInSeconds*fps,
    durationInFrames:Math.max(1,Math.round((item.codeClock.endInSeconds-item.codeClock.startInSeconds)*fps)),
  }:parent,[parent,item.codeClock,fps]);
  return <Internals.SequenceContext.Provider value={context}>{children}</Internals.SequenceContext.Provider>;
}
